<script lang="ts">
import { defineComponent } from 'vue'
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment/moment'
import { listDiscoveryChannelCategory } from '@/api/discovery/discoveryChannelCategory'
import { parseTime } from '@/utils/ruoyi'
import { pageDiscoveryPost } from '@/api/discovery/discoveryPost'

export default defineComponent({
  name: 'DiscoveryPostSelectTable',
  components: {
    CustomDictTag
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        userId: undefined,
        authorName: undefined,
        title: undefined,
        content: undefined,
        contentType: undefined,
        mediaUrls: undefined,
        isRecommend: undefined,
        shelfStatus: undefined,
        postStatus: undefined,
        machineStatus: undefined,
        machineScore: undefined,
        machineLabels: undefined,
        humanStatus: undefined,
        rejectReason: undefined,
        publishTime: undefined,
        viewCnt: undefined,
        commentCnt: undefined,
        likeCnt: undefined,
        collectCnt: undefined,
        topicName: undefined,
        channelId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '120px',
          align: 'center',
          fixed: 'left'
        },
        {
          title: '标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '作者',
          dataIndex: 'authorName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '类型',
          dataIndex: 'contentType',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'contentType' }
        },
        {
          title: '频道',
          dataIndex: 'channelList',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'channelList' }
        },
        {
          title: '话题',
          dataIndex: 'topicList',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'topicList' }
        },
        {
          title: '封面图',
          dataIndex: 'mediaUrls',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'mediaUrls' }
        },
        {
          title: '浏览量',
          dataIndex: 'viewCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '评论量',
          dataIndex: 'commentCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '点赞量',
          dataIndex: 'likeCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '收藏量',
          dataIndex: 'collectCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '推荐',
          dataIndex: 'isRecommend',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isRecommend' }
        },
        {
          title: '上架状态',
          dataIndex: 'shelfStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'shelfStatus' }
        },
        {
          title: '状态',
          dataIndex: 'postStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'postStatus' }
        },
        {
          title: '拒绝原因',
          dataIndex: 'rejectReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '发布时间',
          dataIndex: 'publishTime',
          scopedSlots: { customRender: 'publishTime' },
          ellipsis: true,
          align: 'center',
          width: '180px'
        }
      ],
      channelList: [],
      opened: false
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    openDrawer() {
      this.opened = true
      this.getChannelList()
      this.handleUnselectAll()
      this.resetQuery()
      this.handleQuery()
    },
    handleClose() {
      this.opened = false
    },
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getChannelList() {
      listDiscoveryChannelCategory({}).then(response => {
        this.channelList = response.data
      })
    },
    /** 查询发现-帖子列表 */
    getList() {
      this.loading = true
      pageDiscoveryPost(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        userId: undefined,
        authorName: undefined,
        title: undefined,
        content: undefined,
        contentType: undefined,
        mediaUrls: undefined,
        isRecommend: undefined,
        shelfStatus: 1,
        postStatus: 6,
        machineStatus: undefined,
        machineScore: undefined,
        machineLabels: undefined,
        humanStatus: undefined,
        rejectReason: undefined,
        publishTime: undefined,
        viewCnt: undefined,
        commentCnt: undefined,
        likeCnt: undefined,
        collectCnt: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    handleSelectAll() {
      const ids = this.list.map(item => item.id)
      this.ids = ids
      this.selectedRowKeys = ids
    },
    handleUnselectAll() {
      this.ids = []
      this.selectedRowKeys = []
    },
    handleSubmit() {
      this.$emit('onSubmit', this.ids)
      this.handleClose()
    }
  }
})
</script>

<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="opened" @cancel="handleClose" @close="handleClose">
    <a-divider orientation="left">
      <b>选择帖子</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="6" :sm="24">
              <a-form-item label="标题" prop="title">
                <a-input v-model="queryParam.title" :maxLength="32" :placeholder="$t('请输入')+'帖子标题'" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="频道" prop="channelId">
                <a-select :placeholder="$t('请选择')" v-model="queryParam.channelId" allowClear>
                  <a-select-option v-for="item in channelList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--            <a-col :md="6" :sm="24">-->
            <!--              <a-form-item label="状态" prop="postStatus">-->
            <!--                <a-select :placeholder="$t('请选择')" v-model="queryParam.postStatus" allowClear>-->
            <!--                  <a-select-option :value="0">草稿箱</a-select-option>-->
            <!--                  <a-select-option :value="1">机审中</a-select-option>-->
            <!--                  <a-select-option :value="2">人工审核</a-select-option>-->
            <!--                  <a-select-option :value="3">机审拒绝</a-select-option>-->
            <!--                  <a-select-option :value="4">人审拒绝</a-select-option>-->
            <!--                  <a-select-option :value="5">举报下架</a-select-option>-->
            <!--                  <a-select-option :value="6">发布成功</a-select-option>-->
            <!--                  <a-select-option :value="7">主动下架</a-select-option>-->
            <!--                </a-select>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item label="话题" prop="topicName">
                <a-input v-model="queryParam.topicName" :maxLength="32" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="类型" prop="contentType">
                <a-select :placeholder="$t('请选择')" v-model="queryParam.contentType" allowClear>
                  <a-select-option :value="1">图文</a-select-option>
                  <a-select-option :value="2">视频</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--            <a-col :md="6" :sm="24">-->
            <!--              <a-form-item label="上架状态" prop="shelfStatus">-->
            <!--                <a-select :placeholder="$t('请选择')" v-model="queryParam.shelfStatus" allowClear>-->
            <!--                  <a-select-option :value="0">下架</a-select-option>-->
            <!--                  <a-select-option :value="1">上架</a-select-option>-->
            <!--                </a-select>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="handleSelectAll">
          {{ $t('全选') }}
        </a-button>
        <a-button type="primary" @click="handleUnselectAll">
          {{ $t('取消选择') }}
        </a-button>
        <span>已选择{{ ids.length }}条</span>
      </div>
      <!-- 数据展示 -->
      <a-table
        ref="tableRef"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%' }"
      >
        <template slot="contentType" slot-scope="text, record">
          <span v-if="record.contentType === 1">图文</span>
          <span v-else-if="record.contentType === 2">视频</span>
        </template>
        <template slot="channelList" slot-scope="text, record">
          <span v-if="record.channelList && record.channelList.length > 0">{{ record.channelList.join('、') }}</span>
        </template>
        <template slot="topicList" slot-scope="text, record">
          <span v-if="record.topicList && record.topicList.length > 0">{{ record.topicList.join('、') }}</span>
        </template>
        <template slot="mediaUrls" slot-scope="text, record">
          <div style="width:40px;height:40px;">
            <img
              v-if="record.contentType === 1 && record.mediaUrls && record.mediaUrls.length > 0"
              :src="record.mediaUrls[0]"
              style="width:40px;height:40px;"
              @click="handleRecordPreview(record.mediaUrls[0])"
              alt="none"
            />
          </div>
        </template>
        <template slot="isRecommend" slot-scope="text, record">
          <a-switch :checked="record.isRecommend" disabled></a-switch>
          {{ !record.isRecommend ? '关闭' : '开启' }}
        </template>
        <template slot="shelfStatus" slot-scope="text, record">
          <a-switch :checked="record.shelfStatus === 1" disabled></a-switch>
          {{ record.shelfStatus === 1 ? '上架' : '下架' }}
        </template>
        <template slot="postStatus" slot-scope="text, record">
          <span v-if="record.postStatus === 0">草稿箱</span>
          <span v-else-if="record.postStatus === 1">机审中</span>
          <span v-else-if="record.postStatus === 2">人工审核</span>
          <span v-else-if="record.postStatus === 3">机审拒绝</span>
          <span v-else-if="record.postStatus === 4">人审拒绝</span>
          <span v-else-if="record.postStatus === 5">举报下架</span>
          <span v-else-if="record.postStatus === 6">发布成功</span>
          <span v-else-if="record.postStatus === 7">主动下架</span>
        </template>
        <span slot="publishTime" slot-scope="text, record">
          {{ parseTime(record.publishTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <div class="bottom-control">
      <a-space>
        <a-button type="primary" @click="handleSubmit" :disabled="ids.length <= 0">
          {{ $t('确认') }}
        </a-button>
        <a-button type="dashed" @click="handleClose">
          {{ $t('取消') }}
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<style scoped lang="less">
</style>